module.exports = __webpack_public_path__ + "img/home-toptitle.2a57667a.png";